<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/18TBcuP/tc-custom/9781466822818.jpg?1731007752521" alt="This image is the cover for the book Starworld, To the Stars Trilogy"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Starworld, To the Stars Trilogy
      </h1>
      <p class="bookDescription body article font2">
        <p><b><i>Starworld </i>completes Harry Harrison's epic To the Stars trilogy with one of the most breathtaking space sequences yet seen in science fiction.</b><br/><br/>The twilight planet of Halvmork is free. The Earth space fleet has left to guard the Homeworld and to prepare for the ultimate, cataclysmic showdown. For a moment, the entire galaxy seems to hold its breath...<br/><br/>For Jan Kulozik, exiled on Halvmork, this is the moment of decision. Will he find himself a leader of a new society...or an eternal slave to the absolute power of Earth?<br/><br/><br/>At the Publisher's request, this title is being sold without Digital Rights Management Software (DRM) applied.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Harry Harrison
      </h2>
      
      <p class="authorDescription body article">Harry Harrison (1925&ndash;2012) began writing science fiction in the 1950s and remains one of the top-selling authors in the genre. Harrison is best known for his Stainless Steel Rat, Deathworld, and West of End series, as well as&#160;<I>Make Room! Make Room!</I>, which was turned into the movie&#160;<I>Soylent Green&#160;</I>starring Charlton Heston and Edward G. Robinson. His novels have appeared on the&#160;<I>New York Times</I>&#160;bestseller list, and in 2009 he was awarded the Damon Knight SF Grand Master Award by the Science Fiction Writers of America.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?deaa709a